import {findClosestElementByClass} from '../helpers/dom/closest';
export const tabOffer = {
	init: function () {
		const tabOfferTabs = document.querySelectorAll('[data-tab-offer]');
		// console.log('tabOfferTabs', tabOfferTabs);
		[].forEach.call(tabOfferTabs, el => {
			el.addEventListener('click', e => {
				const tabOffers = findClosestElementByClass(el, 'offer-tabs');
				const tabOfferContents = tabOffers.querySelectorAll('[data-tab-offer-con]');
				const tabOfferId = el.getAttribute('data-tab-offer');
				e.preventDefault();
				[].forEach.call(tabOfferTabs, element => {
					element.classList.remove('active');
				});
				el.classList.add('active');
				[].forEach.call(tabOfferContents, element => {
					if (tabOfferId === element.getAttribute('data-tab-offer-con')) {
						element.classList.remove('is-hidden');
					}
					else {
						element.classList.add('is-hidden');
					}
				
				});

			});
		});
	}
};
